import { OktaAuthOptions } from '@okta/okta-auth-js';
import { getViteAppOktaIssuer } from './utils/Vite/getViteAppOktaIssuer';
import { getViteAppOktaBaseUrl } from './utils/Vite/getViteAppOktaBaseUrl';
import { getViteAppOktaClientId } from './utils/Vite/getViteAppOktaClientId';

// Custom storage that strips refresh tokens from localStorage.
//
// The refresh token is discarded outright, not retained in memory - this object
// is the TokenManager's only store. So renewal always falls back to the hidden
// iframe flow, which needs a third-party cookie. Worth revisiting as those go
// away.
const createSecureStorage = () => {
  return {
    getItem(key: string): string | null {
      return localStorage.getItem(key);
    },
    setItem(key: string, value: string): void {
      try {
        if (key === 'okta-token-storage') {
          const parsed = JSON.parse(value);
          // Remove refresh token before storing in localStorage
          if (parsed.refreshToken) {
            const { refreshToken: _refreshToken, ...safeTokens } = parsed;
            console.log(
              '🔒 Refresh token stripped from localStorage (kept in memory only)'
            );
            localStorage.setItem(key, JSON.stringify(safeTokens));
            return;
          }
        }
        localStorage.setItem(key, value);
      } catch (error) {
        localStorage.setItem(key, value);
      }
    },
    removeItem(key: string): void {
      localStorage.removeItem(key);
    },
  };
};

const oktaAuthConfig: OktaAuthOptions = {
  issuer: getViteAppOktaIssuer(),
  clientId: getViteAppOktaClientId(),
  redirectUri: `${window.location.origin}/implicit/callback`,
  scopes: ['openid', 'profile', 'phone', 'email', 'offline_access'],
  pkce: true,
  tokenManager: {
    storage: createSecureStorage(),
  },
};

const oktaSignInConfig = {
  baseUrl: getViteAppOktaBaseUrl(),
  clientId: getViteAppOktaClientId(),
  redirectUri: `${window.location.origin}/implicit/callback`,
  authParams: {
    issuer: getViteAppOktaIssuer(),
  },
};

export { oktaAuthConfig, oktaSignInConfig };
